<template>
  <div class="all">
    <div class="header-top">
      <span class="header_h">
        <el-button type="primary" plain @click="back">返回</el-button>
      </span>
      <div style=" background-color: #ebefff; width: 100%; height: 1px; margin-top: 10px; " />
      <el-form inline @submit.native.prevent="getPersonList(1)">
        <el-form-item label="账号状态:" class="header_b" style="margin-left: 20px;">
          <el-select v-model="searchQuery.joinStatus" size="small" style="width: 120px" clearable filterable @change="getPersonList(1)" class="isEnabledsty">
            <el-option v-for="item in isqiyongoptions" :key="item.id" :value="item.id" :label="item.label" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="人员类别:" class="header_b">
          <el-select v-model="searchQuery.isExternal" size="small" style="width: 120px" clearable filterable @change="getPersonList(1)" class="isEnabledsty">
            <el-option v-for="item in iswaioptions" :key="item.id" :value="item.id" :label="item.label" />
          </el-select>
        </el-form-item> -->
        <el-form-item class="header_b">
          <el-button size="small" type="danger" plain @click="pldeletePerson" :disabled="this.pageSelect.length == 0"> 批量删除 </el-button>
        </el-form-item>
        <div style="float: right; margin-top: 7px">
          <el-form-item>
            <el-input v-model="searchQuery.keyword" placeholder="请输入姓名、手机号" style="width: 307px" size="small" @input="changeinput" clearable>
              <template #prefix>
                <i class="el-icon-search el-input__icon" @click="getPersonList(1)" />
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="midd">
      <el-table v-loading="loading" :data="tableData" element-loading-text="拼命加载中" class="jk-table" highlight-current-row height="100%" :row-style="rowStyle" :header-cell-style="headerStyle" @row-click="handleDelete" @row-dblclick="detailInfo" @select-all="selectall" @select="selectchange" ref="multipleTable">
        <template slot="empty">
          <img :src="zanwu" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column type="selection" align="center" />
        <el-table-column label="姓名" prop="name" align="center" />
        <el-table-column label="手机号" prop="phone" min-width="120px" align="center" />
        <el-table-column label="部门" prop="depName" min-width="120px" align="center">
          <template slot-scope="scope">
            <span :title="scope.row.depNametitle">{{scope.row.depName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" prop="$joinStatus" min-width="120px" align="center" />
        <el-table-column label="人员类别" prop="isExternal" min-width="120px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isExternal == '1'">外部</span>
            <span v-if="scope.row.isExternal == '0'">内部</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="140px">
          <template slot-scope="scope">
            <span @click="deletePerson(scope.row)" class="btn">删除</span>
            <span @click="copyCode(scope.row)" class="btn">复制链接</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="height: 32px;">
        <div class="page-1">
          <el-pagination @size-change="handleSizeChange" background :total="totalCount" :page-size="pageSize" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next, jumper" @current-change="getPersonList" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import { mapState } from "vuex";
import {  baseUrlWeb} from "@/utils";
export default {
  components: {
  },
  data() {
    return {
      zanwu: require('@/CommonDP/assets/暂无数据.png'),
      loading: false,
      search: "",
      tableData: [],
      searchQuery: {
        keyword: "",
        isExternal: "",
        joinStatus: ""
      },
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      currentRow: {},
      userId: undefined,
      iswaioptions: [ { id: "1", label: "外部" }, { id: "0", label: "内部" } ],
      isqiyongoptions: [ { id: "0", label: "待同意" }, { id: "2", label: "已拒绝" } ],
      pageSelect: [], //勾选的数据
      rows: {},
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
    })
  },
  created() {
    const {type} = this.$route.query
    // type === '0' ? this.$route.meta.prouteName = '内部人员' : this.$route.meta.prouteName = '成员管理'
    this.getPersonList(1);
  },
  methods: {
    changeinput() {
      this.getPersonList(1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPersonList(1);
    },
    // 人员列表接口
    getPersonList(index = 1) {
      const {type} = this.$route.query
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      });
      const { pageSize, searchQuery: { keyword, isExternal, joinStatus }, enterpriseId } = this,
      params = { keyword, pageSize, pageNum: index, joinStatus, isExternal:type, enterpriseId };
      systemPersonService.getNotJoinUserList(params).then(({ data, totalCount, pageIndex }) => {
        const list = data.map(person => {
          const isEnableds = ["待同意", "已加入", '已拒绝'];
          return { depName: '', depNametitle: '', $joinStatus: isEnableds[person.joinStatus], ...person };
        });
        this.pageIndex = pageIndex;
        this.totalCount = totalCount;
        this.tableData = list;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].deptList != null && this.tableData[i].deptList.length) {
            for (var l = 0; l < this.tableData[i].deptList.length; l++) {
              this.tableData[i].depName += this.tableData[i].deptList[l].deptName + ';'
              this.tableData[i].depNametitle += this.tableData[i].deptList[l].fullDeptName + ';'
            }
            //去掉最后一个符号
            this.tableData[i].depName = this.tableData[i].depName.substring(0, this.tableData[i].depName.length - 1)
            this.tableData[i].depNametitle = this.tableData[i].depNametitle.substring(0, this.tableData[i].depNametitle.length - 1)
          }
        }
        var data222 = [];
        for (var s = 0; s < this.pageSelect.length; s++) {
          for (var g = 0; g < this.tableData.length; g++) {
            if (this.pageSelect[s].userId == this.tableData[g].userId) {
              data222.push(this.tableData[g]);
            }
          }
        }
        this.toggleSelection(data222);
        this.userId = undefined;
        this.loading = false;
      });
    },
    // 翻页勾选
    toggleSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 选中的节点
    handleDelete(selection) {
      console.log(selection, "点击");
      this.userId = selection.userId;
      this.currentRow = selection;
    },
    // 删除人员
    deletePerson(row) {
      // const row = this.currentRow;
      const params = {
        userIds: []
      };
      params.userIds.push(row.phone);
      this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        systemPersonService.deleteInviteCodeByIds(params.userIds).then(() => {
          this.getfreshen(); // 刷新列表
          this.$message({
            showClose: true,
            type: "success",
            message: "删除成功"
          });
        }).catch(() => { });
      }).catch(() => {
        this.getfreshen();
      });
      this.userId = undefined;
    },
    // 批量删除人员
    pldeletePerson() {
      const params = {
        userIds: []
      };
      for (var i = 0; i < this.pageSelect.length; i++) {
        params.userIds.push(this.pageSelect[i].phone);
      }
      this.$confirm("此操作将删除数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        systemPersonService.deleteInviteCodeByIds(params.userIds).then(() => {
          this.getfreshen(); // 刷新列表
          this.$message({
            showClose: true,
            type: "success",
            message: "删除成功"
          });
          this.pageSelect = [];
        });
      }).catch(() => {
        this.getfreshen();
      });
    },
    getfreshen() {
      this.getPersonList(1);
    },
    async detailInfo(row) {
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    selectall(rows) {
      if (rows.length) {
        var result = [];
        if (this.pageSelect.length) {
          for (var i = 0; i < this.tableData.length; i++) {
            var obj = this.tableData[i];
            var num = obj.userId;
            var isExist = false;
            for (var j = 0; j < this.pageSelect.length; j++) {
              var aj = this.pageSelect[j];
              var n = aj.userId;
              if (n == num) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              result.push(obj);
            }
          }
          for (var u = 0; u < result.length; u++) {
            this.pageSelect.push(result[u]);
          }
          // console.log(this.pageSelect,"添加全全全勾选");
        } else {
          for (var i = 0; i < this.tableData.length; i++) {
            this.pageSelect.push(this.tableData[i]);
          }
        }
      } else {
        for (var t = 0; t < this.tableData.length; t++) {
          this.removeByValue(
            this.pageSelect,
            "userId",
            this.tableData[t].userId
          );
        }
        // console.log(this.pageSelect,"去掉全全全勾选");
      }
    },
    selectchange(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      if (!selected) {
        this.removeByValue(this.pageSelect, "userId", row.userId);
        // console.log(this.pageSelect,"去掉单勾选");
      } else {
        this.pageSelect.push(row);
        // console.log(this.pageSelect,"添加单勾选");
      }
    },
    // 复选框不勾选时需要调用的函数
    removeByValue(arr, attr, value) {
      //数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] == value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    back() {

      const {type} = this.$route.query
      type === '0' ? this.$router.push({name:'personInfo'}) : this.$router.push({name:'supperManage'});
    },
    copyCode(row) {
      var code = "";
      code = baseUrlWeb() + "/joinEnterprise?code=" + row.inviteCode;
      this.$copyText(code).then(res => {
        this.$message.success("链接复制成功！");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  background: #fff;
  position: relative;
  min-width: 980px;
  .isEnabledsty {
    /deep/ .el-input__suffix {
      top: -3px !important;
    }
  }
}
.header-top {
  padding-top: 15px;
  .icon_1 {
    color: #1089c8;
    font-size: 23px;
  }
  .header_h {
    padding-left: 20px;
    font-size: 16px;
    line-height: 30px;
    font-weight: 600;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #333333;
  }
  .header_b {
    margin-top: 10px;
  }
  .m-b-4 {
    color: #fff;
    border-radius: 5px;
    margin-left: 7px;
    background-color: #009fde;
  }
  .top_r {
    float: right;
    padding-top: 8px;
    .top_s {
      width: 81px;
      margin-right: 7px;
    }
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 36px;
}
.midd {
  position: absolute;
  bottom: 62px;
  left: 0;
  right: 0;
  top: 120px;
  padding-left: 20px;
  .page-1 {
    float: right;
    padding-right: 15px;
  }
}
.tit {
  position: absolute;
  width: 100%;
  bottom: 0px;
  background: pink;
  color: #fff;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
h4 {
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  padding-left: 10px;
  margin-top: 5px;
  background-color: rgb(170, 165, 165);
}
.footer-dialog {
  margin-left: 100px;
}
.d-1 {
  width: 250px;
}
.d-2 {
  width: 100%;
}
.btn{
  cursor: pointer;color:#5584FF;margin-right:6px
}
</style>
